import { render, staticRenderFns } from "./UserList.vue?vue&type=template&id=59f0147a&scoped=true&"
import script from "./UserList.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserList.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserList.vue?vue&type=style&index=0&id=59f0147a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f0147a",
  null
  
)

export default component.exports